module.exports = __webpack_public_path__ + "img/toyama.0739040b.jpg";